'use client';

import { type AdapterMeta } from '@/lib/finance/automation/publishAdapter';

interface AdapterLogoProps {
  meta?: AdapterMeta | undefined;
  size?: number;
  className?: string;
}

/** Renders the adapter's SVG logo when available, falling back to the emoji icon. */
export function AdapterLogo({ meta, size = 20, className }: AdapterLogoProps) {
  if (meta?.logoPath) {
    return (
      <img
        src={meta.logoPath}
        alt={meta.label}
        width={size}
        height={size}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    );
  }
  return <span className={className}>{meta?.icon || '🔌'}</span>;
}
